<template>
  <div>
    <!-- <van-nav-bar title="修改密码" left-text="返回" left-arrow @click-left="onClickLeft"/> -->
    <van-form validate-first validate-trigger="onBlur" @submit="subRegis">
      <van-field v-model="form.password" label="当前密码" placeholder="当前密码" :rules="[{ required: true, message: '请填写当前密码' }]" />
      <!-- 新密码长度至少8位，包含数字和字母 -->
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        新密码长度8-20位 包含数字和字母
      </van-notice-bar>
      <van-field v-model="form.NewPassword1" type="password" label="新的密码" placeholder="新的密码" :rules="[{ validator: validators, message: '请填写格式正确的密码' }]" />
      <van-field v-model="form.NewPassword2" type="password" label="确认密码" placeholder="请填写确认密码" :rules="[{ validator, message: form.msg_Repass}]"/>
      <div style="margin: 16px;">
        <van-button block round size="small" type="info" native-type="submit">修改</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { PasswordChange } from '@/api/user.js'
import { Toast } from 'vant'
export default {
  components: {},
  props: {},
  data () {
    return {
      form: {
        password: '',
        NewPassword1: '',
        NewPassword2: '',
        msg_Repass: '请填写正确的确认密码'
      }
    }
  },
  watch: {},
  computed: {},
  methods: {
    validator () {
      if (this.form.NewPassword1 !== this.form.NewPassword2) {
        this.form.msg_Repass = '请填写正确的确认密码'
        return false
      }
      return true
    },
    validators (val) {
      const pattern = /^(?=.*\d)(?=.*[a-z])[a-zA-Z0-9]{8,}$/
      return pattern.test(val)
    },
    // onClickLeft () { this.$router.go(-1) },
    subRegis () {
      this.PasswordChange()
    },
    // 密码修改
    async PasswordChange () {
      if (!this.form.password || !this.form.NewPassword1 || !this.form.NewPassword2) return
      const { data: res } = await PasswordChange({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], oldPassword: this.form.password, newPassword: this.form.NewPassword2 })
      if (res.code === 0) {
        this.$toast.success('修改成功')
        this.$router.go(-1)
      } else {
        if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
          this.$router.push('/login')
          this.$toast.fail('请重新登录')
        }
        if (res.msg && res.msg.indexOf('当前密码不正确,请重新输入密码') !== -1) return Toast('当前密码输入错误')
        if (res.msg && res.msg.indexOf('新密码格式不符合要求') !== -1) return Toast.fail('新密码格式不符合要求')
      }
    }
  },
  beforeCreate () {},
  created () {
    // this.PasswordChange()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .van-notice-bar {
    margin: 15px 0;
    height: 70px!important;
  }
</style>
